// Trình ký online V2 — màn Tạo / Xem / Phê duyệt tờ trình.
// UI giữ nguyên như V1; logic nằm trong hook useTrinhKy, render tách theo component.
import React from "react";
import { Link, useParams } from "react-router-dom";
import Moment from "react-moment";
import AkkhorLayout from "../layout/akkhor";
import AlertErrorForm from "../component/AlertErrorForm";
import Spinner from "../component/Spinner";
import Loading from "../component/Loading";
import FilePreviewList from "../workflows/FilePreviewList";
import ModalLoaiToTrinh from "../workflows/ModalLoaiToTrinh";
import ModalThemLoaiToTrinhKhac from "../workflows/ModalThemLoaiToTrinhKhac";

import useTrinhKy from "./hooks/useTrinhKy";
import ActivityPanel from "./components/ActivityPanel";
import ProcessStepCreate from "./components/ProcessStepCreate";
import ProcessStepView from "./components/ProcessStepView";
import AddMemberModal from "./components/AddMemberModal";
import { STATUS } from "./constants/trinhKy";

export default function FormToTrinhV2() {
  const { id } = useParams();
  const tk = useTrinhKy(id);
  const {
    user, loading, pageLoading, detail, workfollowId, setWorkfollowId,
    listProgress, setListProgress, reloadProgress, listMessage,
    userComment, setUserComment, buttonLoading, formik,
    handleApprove, handleApproveQues, handleRequestUpdate, giveBack, handleReject,
    myMessage, onComment, sendMessage, usersSuggest, showSuggest, handleSelectUser, inputRef,
    addMember, actionAddMember, deleteStep, handleAddMember, handleRemoveMember, extractFullname,
    tempUser, setTempUser, resetKey, dataNewMember, setDataNewMember, modalAddMember, setModalAddMember,
    huybototrinh, canCancle, roleCancle, mavTitle,
  } = tk;

  const readOnly = (detail && detail.position != 0) || (detail && detail.author_id != user.data.id);
  const isCreate = id === 0 || id === undefined;

  return (
    <AkkhorLayout idrole="workflow_walking">
      <div className="breadcrumbs-area">
        <ul>
          <li><Link to="/">Trang chủ</Link></li>
          <li><Link to="/workflow_walking">Danh sách tờ trình</Link></li>
          <li>{mavTitle()}</li>
        </ul>
      </div>

      <div className="card height-auto">
        <div className="card-body pb-5">
          <div className="heading-layout1">
            <div className="item-title"><h3>{mavTitle()}</h3></div>
            <div className="">
              {detail && (
                <>
                  {detail.status == 1 && <span className="p-2 border border-info rounded text-info">Chưa hoàn tất</span>}
                  {detail.status == 2 && <span className="p-2 border border-success rounded text-success">Đã được duyệt</span>}
                  {detail.status == 4 && <span className="p-2 border border-danger rounded text-danger">Tờ trình đã bị hủy</span>}
                </>
              )}
            </div>
          </div>
          {pageLoading && <Loading />}
          {id > 0 && !detail && !pageLoading ? (
            "Không tìm thấy tờ trình hoặc bạn không có quyền xem tờ trình này"
          ) : (
            <form className="new-added-form form-totrinh" onSubmit={formik.handleSubmit}>
              <div className="row">
                <div className="col-12 col-sm-4 form-group">
                  <label>Tên tờ trình <span className="text-danger">*</span></label>
                  {readOnly ? (
                    <div className="form-control">{detail.title}</div>
                  ) : (
                    <input type="text" placeholder="VD: Mua máy tính" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" disabled={readOnly} />
                  )}
                  <AlertErrorForm formik={formik} name="title" />
                </div>
                <div className="col-12 col-sm-4 form-group">
                  <label>Ghi chú</label>
                  {readOnly ? (
                    <div className="form-control" style={{ minHeight: 32 }}>
                      {detail.note_comment ? detail.note_comment : <span className="text-secondary">Ghi chú...</span>}
                    </div>
                  ) : (
                    <input type="text" placeholder="Nhập ghi chú..." className="form-control height32" {...formik.getFieldProps("note_comment")} autoComplete="off" disabled={readOnly} />
                  )}
                  <small>Lưu ý: Khi sử dụng tài khoản phòng ban vui lòng ghi chú người trình kèm MSNV. Ví dụ: Nguyễn Văn A - MS000185</small>
                </div>

                <div className="col-12 col-sm-4 form-group">
                  <label>Số tờ trình <span className="text-danger">*</span></label>
                  {readOnly ? (
                    <div className="form-control">{detail.code}</div>
                  ) : (
                    <input type="text" placeholder="VD: 07/2025/TTr-PCN" className="form-control height32" {...formik.getFieldProps("code")} autoComplete="off" disabled={readOnly} />
                  )}
                  <AlertErrorForm formik={formik} name="code" />
                </div>

                <div className="w-100"></div>
                <div className="col-12 col-sm-3 form-group">
                  <label>Loại tờ trình: </label>
                  {readOnly ? (
                    <div className="form-control">{detail.type_name}</div>
                  ) : (
                    <ModalLoaiToTrinh
                      onChange={(value) => {
                        formik.setFieldValue("type_id", value);
                        setWorkfollowId(value);
                      }}
                    />
                  )}
                </div>
                <div className="col-12 col-sm-3 form-group">
                  <label>Người tạo</label>
                  {isCreate ? (
                    <><strong>{user.data.fullname}|{user.data.part_title}</strong></>
                  ) : (
                    detail && detail.author_name && (
                      <>
                        <strong>{detail.author_name}|{detail.author_department}</strong><br />
                        <small>Ngày tạo: <Moment format="DD/MM/YYYY">{new Date(detail.datecreate * 1000)}</Moment></small>
                      </>
                    )
                  )}
                </div>

                <div className="col-12 col-sm-9 form-group">
                  {detail && detail.status == 2 ? (
                    <div className="w-100">
                      <label>Tờ trình đã được duyệt<span className="text-danger">*</span></label>
                      <FilePreviewList formik={formik} rowname={"file_signed"} detail={detail} id={id} />
                    </div>
                  ) : (
                    <div className="w-100">
                      <label>File Tờ Trình PDF <span className="text-danger">*</span></label>
                      <FilePreviewList formik={formik} rowname={"list_file"} detail={detail} id={id} />
                    </div>
                  )}
                  <hr />
                  <div className="w-100">
                    <label>Tài liệu tham khảo <small style={{ fontSize: 10 }}>(Không bắt buộc và sẽ không cho vào trong file tờ trình chính)</small></label>
                    <FilePreviewList formik={formik} rowname={"file_attachments"} detail={detail} id={id} />
                  </div>
                </div>

                {id > 0 && (
                  <ActivityPanel
                    detail={detail}
                    user={user}
                    listMessage={listMessage}
                    myMessage={myMessage}
                    onComment={onComment}
                    sendMessage={sendMessage}
                    usersSuggest={usersSuggest}
                    showSuggest={showSuggest}
                    handleSelectUser={handleSelectUser}
                    inputRef={inputRef}
                  />
                )}

                <div className="col-12">
                  <div className="row">
                    <h3 className="w-100 text-center mb-3">Quy trình phê duyệt</h3>
                    {reloadProgress && <div className="w-100 d-flex justify-content-center"><Spinner /></div>}
                    {isCreate && workfollowId == 1 && (
                      <ModalThemLoaiToTrinhKhac onChange={(e) => setListProgress(e)} />
                    )}
                    {isCreate
                      ? listProgress.map((step, stepIndex) => (
                          <ProcessStepCreate
                            key={step.id + "_" + stepIndex}
                            step={step}
                            stepIndex={stepIndex}
                            tempUser={tempUser}
                            setTempUser={setTempUser}
                            resetKey={resetKey}
                            handleAddMember={handleAddMember}
                            handleRemoveMember={handleRemoveMember}
                            extractFullname={extractFullname}
                          />
                        ))
                      : detail &&
                        detail.groupedList &&
                        detail.groupedList.map((group) => (
                          <ProcessStepView
                            key={group.position}
                            group={group}
                            detail={detail}
                            user={user}
                            userComment={userComment}
                            setUserComment={setUserComment}
                            buttonLoading={buttonLoading}
                            handleApprove={handleApprove}
                            handleApproveQues={handleApproveQues}
                            handleRequestUpdate={handleRequestUpdate}
                            giveBack={giveBack}
                            handleReject={handleReject}
                            deleteStep={deleteStep}
                            addMember={addMember}
                          />
                        ))}
                  </div>
                </div>

                {(isCreate ||
                  (detail && user.data.id == detail.author_id && detail.position == 0 && detail.status == 1)) && (
                  <div className="col-12 form-group mt-5">
                    <button type="submit" disabled={formik.isSubmitting || loading} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">
                      {loading ? <Spinner /> : <>Gửi tờ trình</>}
                    </button>
                    <button type="reset" onClick={() => formik.resetForm()} className="btn-fill-lg bg-blue-dark btn-hover-yellow">
                      Nhập lại
                    </button>
                  </div>
                )}
              </div>
              {detail && detail.status == 2 && (
                <div className="item-totrinh verified">
                  <div className="wrapper">
                    <img src="https://apihr.bhsgroup.vn/images/logo-bhs-signed.png" alt="signed" />
                  </div>
                </div>
              )}
              {detail && detail.status == 4 && (
                <div className="item-totrinh verified">
                  <div className="wrapper">
                    <h3 className="text-danger p-3 border border-danger rounded">Tờ trình đã bị hủy</h3>
                  </div>
                </div>
              )}
            </form>
          )}
          {((detail && detail.status != STATUS.CANCELED && roleCancle) || canCancle) && (
            <div className="col-12 text-center form-group mt-5">
              <button type="button" onClick={() => huybototrinh()} className="btn btn-danger">
                Hủy bỏ tờ trình
              </button>
            </div>
          )}
          <div className="w-100 mb-5"></div>
        </div>
      </div>

      <AddMemberModal
        show={modalAddMember}
        onHide={() => {
          setModalAddMember(false);
          setDataNewMember(null);
        }}
        dataNewMember={dataNewMember}
        setDataNewMember={setDataNewMember}
        actionAddMember={actionAddMember}
      />
    </AkkhorLayout>
  );
}
